import { OperationSource } from '../panorama';

export interface IOperationContext {
  readonly currentOperationId: string;
  readonly currentSource: OperationSource | undefined;
}

export function createOperationContext(
  source?: OperationSource,
): IOperationContext {
  return { currentOperationId: crypto.randomUUID(), currentSource: source };
}
